// src/components/Footer/Footer.jsx
import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p><span>Binkley Preschool </span><br/> 1712 Willow Dr, Chapel Hill, NC 27514 🩵

(919) 968-1427 <br/>

Copyright © {new Date().getFullYear()}  Binkley Preschool</p>
      </div>
    </footer>
  );
};

export default Footer;
